export default __webpack_public_path__ + "static/media/metal_mask.d35906b8.png";